import ApiService from "./ApiService";

export async function apiGetAllProcess(data) {
    return ApiService.fetchData({
      url: "/process",
      method: "get",
      data,
    });
  }

  export async function apiGetAllProduction(data) {
    return ApiService.fetchData({
      url: "/production/plan",
      method: "post",
      data,
    });
  }

  export async function apiGetAllProduct(data) {
    return ApiService.fetchData({
      url: "/product/by/order/id",
      method: "post",
      data,
    });
  }
  export async function apiGetAllWorker(data) {
    return ApiService.fetchData({
      url: "/worker/available/worker",
      method: "post",
      data,
    });
  }
  export async function apiPostAllProduction(data) {
    return ApiService.fetchData({
      url: "/production/plan/register",
      method: "post",
      data,
    });
  }
  export async function apiDeleteProductionPlan(data) {
    return ApiService.fetchData({
      url: "/production/plan/delete/id",
      method: "delete",
      data,
    });
  }
  export async function apiProductionPlan(data) {
    return ApiService.fetchData({
      url: "/production/plan/id",
      method: "post",
      data,
    });
  }